import { useCallback } from "react";
function useActions(defaultValue, validateOnChange, fieldApi) {
  const { addArrayElements, swapArrayElements, clearArrayElements, changeArrayElement, removeArrayElements } = fieldApi;
  const addItem = useCallback(
    (value = defaultValue) => {
      addArrayElements("end", value);
      validateOnChange();
    },
    [addArrayElements, validateOnChange, defaultValue]
  );
  const deleteItem = useCallback(
    (index) => {
      removeArrayElements(index);
      validateOnChange();
    },
    [removeArrayElements, validateOnChange]
  );
  const changeItem = useCallback(
    (index, value) => {
      changeArrayElement(index, value);
      validateOnChange();
    },
    [changeArrayElement, validateOnChange]
  );
  const swapItems = useCallback(
    (indexA, indexB) => {
      swapArrayElements(indexA, indexB);
      validateOnChange();
    },
    [swapArrayElements, validateOnChange]
  );
  return { addItem, deleteItem, changeItem, swapItems, clearItems: clearArrayElements };
}
export {
  useActions
};
//# sourceMappingURL=useActions.js.map
